function modal() {
    const modals = document.querySelectorAll('dialog');
    const openers = document.querySelectorAll('[data-modal]');

    if (!modals) {
        return;
    }

    openers.forEach(opener => {
        const targetModal = document.querySelector(opener.getAttribute('data-modal'));
        
        const modalCloseButton = targetModal.querySelectorAll('.mail-wall__close');
        opener.addEventListener('click', function (e) {
            targetModal.showModal();
        });

        modalCloseButton.forEach(button => {
            button.addEventListener('click', function (e) {
                e.target.closest('dialog').close();
            });
        });
    });

    modals.forEach(theModal => {
        // Close modal when clicking on backdrop
        theModal.addEventListener('click', function(event) {
            const rect = theModal.getBoundingClientRect();
            const isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
            rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
            if (!isInDialog) {
                theModal.close();
            }
        });
    });
}

export { modal };